/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryClient } from 'react-query';
import { useDeleteTagMutation } from 'src/graphql';
import { TRootState } from 'src/store';

type CreateTagArgs = {
  mutationDeleteTag: ReturnType<typeof useDeleteTagMutation>['mutateAsync'];
  queryClient: QueryClient;
  tagId?: string;
};

export const deleteTagAction = createAsyncThunk<
  void,
  CreateTagArgs,
  { state: TRootState }
>(
  'tagType/tagDeleted',

  async ({ tagId, mutationDeleteTag, queryClient }: CreateTagArgs) => {
    if (!tagId) {
      return;
    }
    await mutationDeleteTag({
      tagId,
    });

    queryClient.invalidateQueries('getOrganisationTagTypes');
  },
);
